<template>
  <div class="promotion-dialog-wrapper" v-show="visible">
    <div class="promotion-dialog">
      <div class="promotion-dialog__top">
        <div class="promotion-dialog__top__close-btn" @click="handleClose"></div>
        <div class="promotion-dialog__top__content small">{{ message }}</div>
      </div>
      <div class="promotion-dialog__bottom">
        <a class="button" @click="handleClose" href="javascript:">好的</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promotion-dialog',
  data () {
    return {
      visible: false,
      message: ''
    }
  },
  methods: {
    afterLeave () {
      this.$el.parentNode.removeChild(this.$el)
      this.$destroy(true)
    },
    show () {
      this.visible = true
    },
    hidden () {
      this.visible = false
    },
    handleClose () {
      this.hidden()
      this.$emit('ok')
    }
  }
}
</script>

<style lang="scss" scoped>
.small {
  font-size: 14px;
}
.promotion-dialog-wrapper{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba($color: #000000, $alpha: .7)
}
.promotion-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 466px;
  padding: 0 23px;
  border-radius: 3px;
  overflow: hidden;
  background: #ffffff;
  z-index: 100;
  .promotion-dialog__top {
    position: relative;
    .promotion-dialog__top__content {
      padding-top: 96px;
      text-align: center;
      font-size: 16px;
      color: #333333;
    }
    .promotion-dialog__top__close-btn {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 20px;
      right: 0;
      background-image: url('./close-btn-gray.png');
      background-size: cover;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    .promotion-dialog__top__bg {
      width: 286px;
      height: 100%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      background-size: 286px 82px;
      background-repeat: no-repeat;
      background-position: center bottom;
    }
  }
  .promotion-dialog__bottom {
    padding-top: 62px;
    padding-bottom: 32px;
    position: relative;
    .button {
      width: 130px;
      height: 40px;
      display: block;
      margin: 0 auto;
      color: #fff;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      background: #f13232;
      border-radius: 3px;
      cursor: pointer;
      text-decoration-line: none;
    }
    .des {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 25px;
      text-align: center;
      font-size: 10px;
      color: #999999;
    }
  }
}
</style>
